module.exports = __webpack_public_path__ + "public/images/unicorn.28b48010049d20e8517206329dcbdcdc.png";